//Accordion
let accordion = document.querySelectorAll('.accordion');

if(accordion.length > 0){
  accordion.forEach((item) => {
    let accBlock = item.querySelector('.acc-block');
    let btn = item.querySelector('.acc-btn');

    btn.addEventListener('click', function(event){
      event.preventDefault();

      if(accBlock.classList.contains('active')){
        accBlock.classList.remove('active');
      } else {
        accBlock.classList.add('active');
      }
    });
  });
}

//Gallery
let galleryCon = document.querySelector('.gallery-container');

if(galleryCon){
  new Swiper(galleryCon, {
    //slidesPerView: 1,
    spaceBetween: 0,
    freeMode: false,
    loop: true,
    mouseWheel: {
      releaseOnEdges: true,
    },
    navigation: {
      nextEl: galleryCon.querySelector(".swiper-button-next"),
      prevEl: galleryCon.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: galleryCon.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      500: {
        //slidesPerView: 2,
        freeMode: true,
        spaceBetween: 1
      },
    },
  });
}

//Inventory Display
let selectDrop = document.querySelector('.product-atc select');

if(selectDrop){
  let quantityText = document.querySelectorAll('.top .quantity');
  let priceText = document.querySelectorAll('.top .price');

  selectDrop.addEventListener('change', function(event){
    let selectedOption = event.target.selectedOptions[0];
    let inventory = selectedOption.getAttribute('data-inventory');
    console.log(inventory);
    quantityText.forEach((item) => {
      if(inventory == 0){
        item.innerHTML = "Out of stock";
      } else if(inventory < 5){
        item.innerHTML = inventory + " in stock";
      } else {
        item.innerHTML = "In stock";
      }
    });
    
    let price = selectedOption.getAttribute('data-price');
    priceText.forEach((item) => {
      let formattedPrice = Shopify.formatMoney(price).replace(/\.00$/, '');
      item.innerHTML = formattedPrice;
    });
    
  });
}


document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const select = document.querySelector(".variant-select");
    const option = select.querySelector(`option[value="${variantId}"]`);

    if (option) {
      option.selected = true;
      const event = new Event("change", { bubbles: true });
      select.dispatchEvent(event);
    }
  }
});